import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';
import { CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES, getExperimentCohort } from './FeatureFlags';

export type IneligibilityReason =
	| 'NOT_ADMIN'
	| 'NO_INVITE_PERMISSIONS'
	| 'NO_ELIGIBLE_USERS'
	| 'NO_ELIGIBLE_PRODUCTS'
	| 'PRODUCT_NOT_ELIGIBLE';

export class Analytics extends BaseInvitePeopleAnalytics {
	eligibilityChecked(ineligibilityReason: IneligibilityReason | 'ELIGIBLE') {
		this.fireTrack({
			actionSubject: AnalyticsActionSubject.ELIGIBILITY,
			action: AnalyticsAction.CHECKED,
			attributes: {
				flagKey: CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES,
				ineligibilityReason,
			},
		});
	}

	featureExposed() {
		this.fireTrack({
			actionSubject: AnalyticsActionSubject.INVITE_PEOPLE_FEATURE,
			action: AnalyticsAction.EXPOSED,
			attributes: {
				flagKey: CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES,
				cohort: getExperimentCohort({ fireExposure: true }),
			},
		});
	}
}
